import { Label } from "@centricsoftware/design-system";
import clsx from "clsx";
import { FlexRowCenter } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import panelCss from "./FormAttributesPanel.module.css";
import { useFormDefinitionStore } from "./FormDefinitionStore";

const FormAttributesReadOnlyView: FC = observer(() => {
	const { activeField, editPermissionsResource, loc: { attributeResource, resource } } = useFormDefinitionStore();
	const formEditPermissionsConfigurableAttributeText = attributeResource("ConfigurableAttribute", "FormEditPermissions");
	const hiddenConfigurableAttributeText = attributeResource("ConfigurableAttribute", "Hidden");
	const requiredConfigurableAttributeText = attributeResource("ConfigurableAttribute", "Required");
	const formRememberLastValueConfigurableAttributeText = attributeResource("ConfigurableAttribute", "FormRememberLastValue");
	const { transientInfo } = activeField;
	const rememberLastValueText = resource(transientInfo.persistValue);
	const hiddenText = resource(transientInfo.hidden ? "Yes" : "No");
	const requiredText = resource(transientInfo.required ? "Yes" : "No");
	const editPermissionsText = attributeResource("ConfigurableAttribute", editPermissionsResource);

	return (
		<>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label text={requiredConfigurableAttributeText} />
				<span>{requiredText}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.configRow)}>
				<Label text={formEditPermissionsConfigurableAttributeText} />
				<span>{editPermissionsText}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.configRow)}>
				<Label text={hiddenConfigurableAttributeText} />
				<span>{hiddenText}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.configRow)}>
				<Label text={formRememberLastValueConfigurableAttributeText} />
				<span>{rememberLastValueText}</span>
			</FlexRowCenter>
		</>
	);
});

export default FormAttributesReadOnlyView;
